import $ from 'jquery';
import 'jquery';
import './bootstrap';
import smoothscroll from 'smoothscroll-polyfill';
import  Masonry from 'masonry-layout';
import 'clipboard';

import './map-settings';
import './infoModal';
import './projectAjaxMagic';
import umeReadyAccordions from './accordion';
import umeMoreFrontend from './ume-more-frontend';
import umeMenuInit from './menu';
import umeSlidersInit from  './events-slider';
import scrollDownOnClick from './scrollDown';
import projectsModalCreator from "./projectsModalCreator";
import projectShareByUrl from "./projectShareByUrl";
import infoModal from "./loginModal";
import failedLogin from "./failedLogin";
import customLogout from "./customLogout";
import externalLink from "./externalLink";
import shareButton from "./shareButton";
import accordionMobile from "./accordionMobile";
import unsupportedBrowser from './unsupportedBrowser';
import consentmanager from "./consentmanager";
import consentmanagerHandleBackground from "./consentmanagerHandleBackground";

$(document).ready(() => {
    umeMenuInit();
    scrollDownOnClick();
    umeMoreFrontend();
    umeSlidersInit();
    umeReadyAccordions();
    projectsModalCreator();
    projectShareByUrl();
    infoModal();
    failedLogin();
    customLogout();
    externalLink();
    shareButton();
    accordionMobile();
    unsupportedBrowser();
    consentmanager();
    consentmanagerHandleBackground();
    smoothscroll.polyfill();
});